(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["haest-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('haest-header')) {
    class HaestHeader extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.drawer = this.querySelector('[data-haest-drawer]');
        this.drawerSummary = this.drawer?.querySelector('summary');
        this.handleScroll = this.updateScrollState.bind(this);
        this.handleKeydown = this.onKeydown.bind(this);
        this.handleDocumentClick = this.onDocumentClick.bind(this);
        this.handleRootClick = this.onRootClick.bind(this);
        this.handleChange = this.onChange.bind(this);
        this.handleDrawerToggle = this.onDrawerToggle.bind(this);
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        document.addEventListener('keydown', this.handleKeydown);
        document.addEventListener('click', this.handleDocumentClick);
        this.addEventListener('click', this.handleRootClick);
        this.addEventListener('change', this.handleChange);
        this.drawer?.addEventListener('toggle', this.handleDrawerToggle);
        this.updateScrollState();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.handleScroll);
        document.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('click', this.handleDocumentClick);
        this.removeEventListener('click', this.handleRootClick);
        this.removeEventListener('change', this.handleChange);
        this.drawer?.removeEventListener('toggle', this.handleDrawerToggle);
        document.documentElement.classList.remove('haest-menu-open');
        this.bound = false;
      }

      updateScrollState() {
        this.toggleAttribute('data-scrolled', window.scrollY > 20);
      }

      onChange(event) {
        if (!event.target.matches('[data-haest-localization-select]')) return;
        event.target.form?.requestSubmit();
      }

      onRootClick(event) {
        if (event.target.closest('[data-haest-drawer-close]')) {
          this.closeDrawer(true);
          return;
        }
        if (event.target.closest('.haest-header__drawer-panel a')) this.closeDrawer(false);

        const currentMenu = event.target.closest('.haest-header__menu-details');
        if (!currentMenu) return;
        this.querySelectorAll('.haest-header__menu-details[open]').forEach((details) => {
          if (details !== currentMenu) details.open = false;
        });
      }

      onDocumentClick(event) {
        if (this.contains(event.target)) return;
        this.closeDesktopMenus();
      }

      onKeydown(event) {
        if (event.key === 'Tab' && this.drawer?.open) {
          const panel = this.drawer.querySelector('.haest-header__drawer-panel');
          const focusable = [...panel.querySelectorAll('a[href], button:not([disabled]), summary, select, [tabindex]:not([tabindex="-1"])')]
            .filter((element) => element.offsetParent !== null);
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last?.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first?.focus();
          }
          return;
        }

        if (event.key !== 'Escape') return;
        if (this.drawer?.open) return this.closeDrawer(true);
        this.closeDesktopMenus();
      }

      onDrawerToggle() {
        const isOpen = Boolean(this.drawer?.open);
        document.documentElement.classList.toggle('haest-menu-open', isOpen);
        if (isOpen) {
          window.setTimeout(() => this.querySelector('.haest-header__drawer-close')?.focus(), 0);
        }
      }

      closeDrawer(restoreFocus) {
        if (!this.drawer?.open) return;
        this.drawer.open = false;
        this.drawer.querySelectorAll('.haest-header__mobile-submenu[open]').forEach((details) => {
          details.open = false;
        });
        if (restoreFocus) this.drawerSummary?.focus();
      }

      closeDesktopMenus() {
        this.querySelectorAll('.haest-header__menu-details[open]').forEach((details) => {
          details.open = false;
        });
      }
    }

    customElements.define('haest-header', HaestHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haest-main-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('haest-collection')) {
    class HaestCollection extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-haest-collection-form]');
        this.sort = this.querySelector('[data-haest-sort-select]');
        this.details = this.querySelector('[data-haest-filter-details]');
        this.handleSort = this.onSort.bind(this);
        this.handleDocumentClick = this.onDocumentClick.bind(this);
        this.handleKeydown = this.onKeydown.bind(this);
        this.sort?.addEventListener('change', this.handleSort);
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleKeydown);
      }

      disconnectedCallback() {
        this.sort?.removeEventListener('change', this.handleSort);
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleKeydown);
      }

      onSort() {
        this.form?.requestSubmit();
      }

      onDocumentClick(event) {
        if (!this.details?.open || this.details.contains(event.target)) return;
        this.details.open = false;
      }

      onKeydown(event) {
        if (event.key === 'Escape' && this.details?.open) {
          this.details.open = false;
          this.details.querySelector('summary')?.focus();
        }
      }
    }

    customElements.define('haest-collection', HaestCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haest-product-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('haest-related-products')) {
    customElements.define(
      'haest-related-products',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.loaded === 'true' || !this.dataset.url) return;

          this.dataset.loaded = 'true';

          const loadRecommendations = () => {
            fetch(this.dataset.url, { credentials: 'same-origin' })
              .then((response) => response.text())
              .then((text) => {
                const documentFragment = new DOMParser().parseFromString(text, 'text/html');
                const replacement = documentFragment.querySelector('haest-related-products');

                if (replacement && replacement.innerHTML.trim()) {
                  this.innerHTML = replacement.innerHTML;
                  this.setAttribute('aria-busy', 'false');
                } else {
                  this.hidden = true;
                  this.setAttribute('aria-busy', 'false');
                }
              })
              .catch(() => {
                this.setAttribute('aria-busy', 'false');
              });
          };

          if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver(
              (entries) => {
                if (!entries[0].isIntersecting) return;
                observer.disconnect();
                loadRecommendations();
              },
              { rootMargin: '0px 0px 300px 0px' }
            );
            observer.observe(this);
          } else {
            loadRecommendations();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
